<template>
    <b-modal id="signalProcess" size="xl" :centered="true" :visible="state" @hide="onHide" @cancel="onCancel" @shown="startTimer" scrollable>
        {{ signal }}
        <!-- Modal Header -->
            <template #modal-header>
                <div class="info">
                    <b-alert class="account" variant="info" show v-b-popover.hover="popoverConfig(detail.account_info && detail.account_info.part_list)">
                        {{signal.account_no}} - {{ signal.part_no}} {{signal.account_info.name}}
                    </b-alert>
                    <div class="signal alert" :style="'background:'+ signal.signal_settings.background_color+'; color:' +signal.signal_settings.font_color"> 
                        0.{{signal.zone_desc}} {{signal.signal_settings.description}}
                    </div>
                    <b-alert variant="warning" show class="timer"> {{ prettyTime }} </b-alert>
                </div>
            </template>

            <template class="footer" #modal-footer>
                <div class="evoNote"> 
                    <span class="evoText"> {{$t('signal.signalProcess.evaluation')}} </span> 
                    <b-form-select :options="results" value-field="id" text-field="description" v-model="evaluationResult" />
                </div>
                <b-dropdown variant="warning" style="margin-right: 1rem">
                    <template slot="button-content"> 
                        {{$t('account.otherActions')}}
                        </template>
                    <b-dropdown-item @click="otherTabClick('Location', 6)"> {{$t('account.location')}} </b-dropdown-item>
                    <b-dropdown-item @click="otherTabClick('NoteHistory', 6)"> {{$t('signal.list.noteHistory')}} </b-dropdown-item>
                    <b-dropdown-item @click="otherTabClick('CreateServiceForm', 6)"> {{$t('customer.list.serviceForm')}} </b-dropdown-item>
                    <b-dropdown-item v-if="signal.signal_settings.is_postpone" @click="otherTabClick('PostPoneSignal', 6)"> {{$t('signal.list.postpone')}} </b-dropdown-item>
                    <b-dropdown-item @click="otherTabClick('Cameras', 6)"> {{$t('signal.list.cameraList')}} </b-dropdown-item>
                    <b-dropdown-item @click="otherTabClick('Devices', 6)"> Abone Cihazları </b-dropdown-item>

                </b-dropdown>
                <b-button variant="dark" @click="onCancel"> {{$t('signal.signalProcess.dropSignal')}} </b-button>
                <b-button variant="danger" @click="onProcess"> {{$t('signal.signalProcess.processSignal')}} </b-button>

            </template>
        <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
        <template v-else>
            <b-modal :visible="true" size="xl" :centered="true" scrollable v-if="signal.is_processed" ok-title="Tamam" :ok-only="true">
                <p>
                    <strong> {{$t('signal.signalProcess.alreadyProcess')}} </strong>
                </p>

                <b-table-simple >
                        <b-thead>
                            <b-th> {{$t('signal.list.signalsDate')}} </b-th>
                            <b-th> {{$t('signal.list.processDate')}} </b-th>
                            <b-th> {{$t('signal.list.time')}} </b-th>
                            <b-th> {{$t('signal.alarmStatus.account')}} </b-th>
                            <b-th> {{$t('signal.list.userNote')}} </b-th>
                        </b-thead>
                        <b-tbody>
                            <b-tr v-for="note in signal.signal_note" :key="note.date" v-b-popover.hover="popoverConfigUser(contact)"> 
                                <b-td> {{dateFormat(signal.signal_date)}} </b-td>
                                <b-td> {{dateFormat(note.date)}} </b-td>
                                <b-td> <b-badge :variant="getVariant(duration(note.date, signal.signal_date ))"> {{processTime(note.date, signal.signal_date )}} </b-badge> </b-td>
                                <b-td> {{note.user_info.username}} </b-td>
                                <b-td > {{note.note}} </b-td>  
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
            </b-modal>
            <AccountModal />
            
            <!-- Sinyal İşleme Bilgileri -->
            <div class="process">
                <div class="note"  >
                    <b-form-textarea id="signalNote" :placeholder="$t('signal.signalProcess.evaluationPlaceholder')" v-model="note" rows="4" @contextmenu="openMenu($event)" @click="closeMenu" ></b-form-textarea>
                    <!-- Hızlı Notlar -->
                    <ul id="right-click-menu" tabindex="-1" ref="right" v-if="viewMenu" :style="'top:'+top+'; left:'+left+';'">
                        <li v-for="note in notes" :key="note" @click="addNote">{{note.description}}</li>
                    </ul>
                    <!-- Adres -->
                    <div class="address" v-if="detail.account_info && detail.account_info.address"> 
                        <b>Adres: </b> {{detail.account_info.address.pk}}, {{detail.account_info.address.address}} {{detail.account_info.address.town.name}} 
                        / {{detail.account_info.address.city.name}} / {{detail.account_info.address.country.name}}  
                    </div>
                </div>
                <div class="contacts" v-if="detail.account_info">
                    <b-table-simple >
                        <b-thead>
                            <b-th> {{$t('signal.signalProcess.name')}} </b-th>
                            <b-th> {{$t('signal.signalProcess.password')}} </b-th>
                            <b-th> {{$t('signal.signalProcess.centralPassword')}} </b-th>
                        </b-thead>
                        <b-tbody>
                            <b-tr v-for="contact in detail.account_info.contact_user" :key="contact.id" v-b-popover.hover="popoverConfigUser(contact)"> 
                                <b-td> {{contact.name}} </b-td>
                                <b-td> {{maskPwd(contact.password)}} </b-td>
                                <b-td > {{maskPwd(contact.alr_pass)}} </b-td>  
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </div>
            </div>
            <!-- Müşteri Detayları -->
            <div>
                <b-tabs :value="activeIndex">
                    <b-tab class="acoountDetail">
                        <template #title>
                            <b-icon icon="house-door-fill" /> {{$t('signal.signalProcess.generalInfo')}}
                        </template>
                        <GeneralInfo :data="detail" />
                    </b-tab>

                    <b-tab class="acoountDetail">
                        <template #title>
                            <b-icon icon="bell-fill" /> {{$t('signal.signalProcess.signals')}}
                        </template>
                        <Table :fields="fields" :items="detail.signal" :filtered="filtered" type="AlarmDetail" />
                    </b-tab>

                    <b-tab class="acoountDetail">
                        <template #title>
                            <b-icon icon="people-fill" /> {{$t('signal.signalProcess.panelUsers')}}
                        </template>
                        <PanelUsers :data="detail" />
                    </b-tab>
                    <b-tab class="acoountDetail">
                        <template #title>
                            <b-icon icon="clock-history" /> {{$t('signal.signalProcess.workHours')}}
                        </template>
                        <WorkHours :hourList="detail.account_info ? detail.account_info.hours ? detail.account_info.hours : [] : []"/>
                    </b-tab>
                    <b-tab class="acoountDetail">
                        <template #title>
                            <b-icon icon="columns-gap" /> {{$t('signal.signalProcess.zones')}}
                        </template>
                        <Zones :data="detail" />
                    </b-tab>
                    <b-tab class="acoountDetail">
                        <template #title>
                            <b-icon icon="shield-fill-check" /> {{$t('signal.signalProcess.alarmStates')}}
                        </template>
                        <AlarmStatus :data="detail" />
                    </b-tab>
                    <b-tab :title="otherTab" @click="pageSettings(true, otherTab)">
                        <b-card-text> 
                            <component v-bind:is="otherTab" :modalType="pageSettings" :modalEvent="openModal" :data="otherData"></component>
                        </b-card-text>
                    </b-tab>
                </b-tabs>
            </div>
        </template>
        <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" />
    </b-modal>
</template>

<script>
    import GeneralInfo from './GeneralInfo'
    import Table from "./Table"
    import PanelUsers from './PanelUsers'
    import Zones from './Zones'
    import WorkHours from '@/components/WorkHours'
    import AlarmStatus from './AlarmStatus'
    import Location from "../../Account/components/Location"
    import i18n from '@/plugins/i18n'
    import moment from 'moment'
    import humanizeDuration from 'humanize-duration'
    import NoteHistory from '../modals/NoteHistory.vue'
    import PostPoneSignal from '../modals/Postpone.vue'
   // import CreateServiceForm from "../../../General/Dealer/AddService"
    import Cameras from "../../Account/components/CameraList"
    import Devices from "../../Account/components/DeviceList"
    import Modals from "../../Account/modals"




     let fields = [
        { key: 'priorty', label: i18n.t('signal.list.priority') },
        { key: 'signal_date', label: i18n.t('signal.list.signalDate') },
        { key: 'alarm_code', label: i18n.t('signal.list.alarmCode') },
        { key: 'signal_settings', label: i18n.t('signal.list.signalSettings') },
        { key: 'zone_desc', label: i18n.t('signal.list.zoneDesc') },
        { key: 'user', label: i18n.t('signal.list.user') },
        { key: 'note', label: i18n.t('signal.list.signalNotes') },
    ];

    let filtered = ['priorty','signal_date',  'alarm_code', 'signal_settings', 'zone_desc'];

    let infoFieldsContact = {
        user: [
            {key: "name", label: i18n.t('signal.signalProcess.name')},
            {key: "phones", label: i18n.t('signal.signalProcess.phone')},
        ],
    }   
    export default {
        name: 'SignalProcess',
        data: () => {
            return {
                activeIndex: 0,
                hours: 0,
                minutes: 0,
                secondes: 0,
                timer: 0,
                viewMenu: false,
                top: '0px',
                left: '0px',
                fields,
                filtered,
                infoFieldsContact,
                note: '',
                complate: false,
                otherData: {},
                evaluationResult: 0,
                masks : [],
                otherTab: '',
                modalOpen: false,
                modalProps: {},
                modalName: null,
                currentForm: 'Account'
            }
        },
        components:{
            Table, GeneralInfo, PanelUsers, Zones, WorkHours, AlarmStatus, Location, NoteHistory, PostPoneSignal,
            Cameras, Modals, Devices
        },
        computed: {
            loading() {
                return this.$store.getters.getSignalLoading;
            },
            detail(){
                return this.$store.getters.getSignalDetail
            },
            users(){
                return this.$store.getters.getAccountUsers
            },
            notes() {
                return this.$store.getters.getQuickNotes;
            },
            results() {
                return this.$store.getters.getEvaluationResults;
            },
            // Timer değişkenindeki sayacı dakika ve saniyeye çeviriyoruz
            prettyTime(){
                let time = this.timer / 60
                let hours = parseInt(time / 60)
                let minutes = parseInt(time - (parseInt(hours) * 60))
                let secondes = Math.round((time - ((hours * 60) + minutes)) *60 )
                hours < 10 ? hours = '0' + hours : hours
                minutes < 10 ? minutes = '0' + minutes : minutes
                secondes < 10 ? secondes = '0' + secondes : secondes
                return hours +":" +minutes + ":" + secondes
            }
        },
        methods: {
            openModal: function(state, modal, props){
                console.log(state, modal, props)
                this.modalOpen = state
                if(state){
                    this.modalProps = props
                    this.modalName = modal
                }
            },
            processTime: function(noteDate, signalDate){
                return humanizeDuration(moment.duration(moment(noteDate).diff(moment(signalDate))),{ language: localStorage.getItem('lang') })
            },
            duration: function(noteDate, signalDate){
                return moment(noteDate).diff(moment(signalDate), 'second')
            },
            getVariant: function(data){
                if(data < 61){
                    return 'primary'
                }else if(data < 301){
                    return 'success'
                }else if(data < 901){
                    return 'warning'
                }else{
                    return 'danger'
                }
            },
            otherTabClick: function(val, index){
              this.otherTab = val
              this.activeIndex = index
              this.pageSettings(true, val)     
            },
             dateFormat(val){
                return moment(String(val)).format('DD.MM.YYYY HH:mm') 
            },
            pageSettings: function(state, form, data){
                switch(form){
                    case 'Location':
                        this.otherData = this.$store.getters.getSignalDetail.account_info
                        this.activeIndex = 6
                        return
                    case 'NoteHistory':
                        this.otherData = this.signal
                        this.activeIndex = 6
                        return
                    case 'CreateServiceForm':
                        this.otherData = {info: this.signal}
                        this.activeIndex = 6
                        return
                    case 'PostPoneSignal':
                        this.otherData = this.signal
                        this.otherData.type = "process"
                        this.activeIndex = 6
                        return
                    case 'Cameras':
                        this.otherData = this.$store.getters.getSignalDetail.account_info
                        this.otherData.isProcess = true
                        this.activeIndex = 6
                        this.$store.dispatch('getAccountCameras', {accountId: this.$store.getters.getSignalDetail.account_info.ID})
                        return
                     case 'Devices':
                        this.otherData = this.$store.getters.getSignalDetail.account_info
                        this.otherData.isProcess = true
                        this.activeIndex = 6
                        this.$store.dispatch('devices_get', {parent_id: this.$store.getters.getSignalDetail.account_info.ID})
                        return
                }
            },
            startTimer: function(){
                this.timer = 0
                this.minutes = 0
                this.secondes = 0
                this.complate = false,
                this.evaluationResult = 0
                this.note = ''
                this.masks = []
                this.time = setInterval( () => {
                    this.timer = this.timer + 1
                }, 1000)
            },
            maskPwd: function(pwd){
                var arr = [];
                if(pwd.length > 2){
                    let beforePwd = this.masks.find(m => m.pwd == pwd)
                    if(beforePwd){
                        return beforePwd.mask
                    }else{
                        var maskedPwd = new Array(pwd.length).fill('*',0,pwd.length)
                        let pwdArr = pwd.split('')
                        while(arr.length < 2){
                            var r = Math.floor(Math.random() * pwd.length);
                            if(arr.indexOf(r) === -1) {
                                maskedPwd[r] = pwdArr[r]
                                arr.push(r);
                            }
                        }
                        this.masks.push({pwd:pwd, mask: maskedPwd.join('')})
                        return maskedPwd.join('')
                    }
                    
                }
                return pwd
            },
            onHide: function(){
                this.timer = 0
                clearInterval(this.time);
                if(this.complate)
                    this.modalEvent(false)
                else
                    this.modalEvent(false,'cancel', this.signal)
            },
            onCancel: function(){
               this.timer = 0
                clearInterval(this.time);

              this.complate = true  
              this.modalEvent(false,'cancel', this.signal)
            },
            onProcess: function(){
                if(this.evaluationResult > 0 && this.note.length > 3){
                    this.timer = 0
                    clearInterval(this.time);
                    this.complate = true  
                    this.modalEvent(false,'process', this.signal, this.note, this.evaluationResult)
                }else{
                    this.$bvToast.toast(i18n.t('signal.signalProcess.noNoteorResultTitle'), {
                        title: i18n.t('signal.signalProcess.noNoteorResultMsg'),
                        variant: 'danger',
                        solid: true
                    })
                }
            },
            // not a sağ tıklanınca açılan menünün konumlarını belirler.
            setMenu: function(top, left) {
                this.top = top + 'px';
                this.left = left + 'px';
            },
            // Nota sağ tıklayınca açılan menünün kapanmasını sağlar
            closeMenu: function() {
                this.viewMenu = false;
            },
            // nota sağ  tıklayınca menünün açılmasını sağlar
            openMenu: function(e) {
                this.viewMenu = true;
                this.setMenu(e.layerY, e.layerX)
                e.preventDefault();
            },
            // nota sağ tıklayınca açılan menünüye tıklanınca hızlı notu eklemeyi sağlar
            addNote: function(e){
                this.note = this.note + e.target.innerText
                this.viewMenu = false;
            },
             popoverConfigUser(data) {
                console.log(data)
                    return {
                        html: true,
                        placement: 'bottom',
                        customClass: 'popoverFluid',
                        content: () => {
                            let content = data.name + "<br /> <hr/>"
                            for(let i = 0; i < data.user_info.length; i++){
                                content += '<strong>'+ i18n.t('signal.signalProcess.phone')+' '+(i+1)+': </strong><a href="">'+data.user_info[i].phone_no+'</a><br />';
                            }
                            return content
                        },
                    }
                },
            popoverConfig(data) {
                return {
                    html: true,
                    placement: 'bottom',
                    customClass: 'popoverFluid',
                    content: () => {
                        let content = ""
                        if(data)
                            for( let i = 0; i < data.length; i++)
                                content += '<strong> Part No: </strong>'+ data[i].part_no+ ' <strong>'+i18n.t('signal.list.accountInfo')+': </strong>'+ data[i].name +'<br />'
                        return content
                    },
                }
            },
        },
        props:{
            state: Boolean,
            modalEvent: Function,
            signal: Object
        }
    }
</script>

<style lang="css" scoped> 
    @import "../styles/signal.min.css"; 
    @import "../../Account/styles/infoCard.min.css";
</style>


// WEBPACK FOOTER //
// src/pages/Alarmsis/Signal/components/SignalProcess.vue